import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/** A different studio/member/credential is a new form owner, even on the same route definition. */
@Injectable()
export class RegistrationRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig?.data?.['registrationEntry'] && JSON.stringify(future.params) !== JSON.stringify(current.params)) return false;
    return super.shouldReuseRoute(future, current);
  }
}
